import React from "react";
import { MuiChipsInput } from "mui-chips-input";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  input: {
    paddingTop: "30px !important"
  }
}));

const ChipInput = ({ field, form, label, InputProps, inputProps }) => {
  const currentError = form.touched[field.name] && form.errors[field.name];
  const classes = useStyles();

  const handleChange = newValue => {
    form.setFieldValue(field.name, newValue);
  };

  return (
    <MuiChipsInput
      fullWidth
      label={label}
      helperText={currentError}
      error={Boolean(currentError)}
      InputProps={{
        className: classes.input,
        ...InputProps
      }}
      inputProps={{
        ...inputProps
      }}
      variant="filled"
      value={field.value}
      onChange={handleChange}
    />
  );
};

export default ChipInput;
